import '../index.css';
import Nav from 'react-bootstrap/Nav';
import Container from 'react-bootstrap/esm/Container';
import Navbar from 'react-bootstrap/Navbar';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ContactOffcanvas from './ContactOffcanvas';

function FooterNav() {
    return (
        <div className='footerNav'>
          
           <Navbar className='shadow' sticky='bottom' bg="dark" data-bs-theme="dark" > 
        
        <Navbar.Toggle aria-controls="footernav" />
        <Navbar.Collapse id="footernav">
          <Container className='footernav' fluid >
            <Row>
          <Nav justify fill="true"className='gohead' >
            <Nav.Item>
                <Nav.Link href='https://www.instagram.com/apexperformancefit?igsh=MWt1NXBucWszNWZyaQ=='><img
                    alt='Instagram'
                    src='img/instagram icon.png'
                    width={30}
                    height={30}
                    />
                  </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link href="#home">Home</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <ContactOffcanvas name={'Contact'} buttonVariant={'none'}/>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link href='https://vitalifestores.com/'>Vitalife</Nav.Link>
            </Nav.Item>
            
            <Nav.Item>
                  <Nav.Link><img
                    alt='Facebook'
                    src='img/facebook Icon.png'
                    width={30}
                    height={30}
                    />
                  </Nav.Link>
              </Nav.Item>
          </Nav>
          </Row>
          <Row className='border-top pt-3'>
            <Col>
              <img src='img/Wordmark NoSub White.svg'
              alt='Wordmark White'
              width='100%'
              height={50}
              />
            </Col>

            <Col>
            
            <img src='img/OFC Vert White.svg'
            alt='Online Fitness Coaching'
            width='100%'
            height={50}
            />
            </Col>
          </Row>
          </Container>
          
            
          
        </Navbar.Collapse>
        
    </Navbar> 
    
      

        
      


        </div>
        

    );
}

export default FooterNav;